import React from 'react';
import Sidebar from './Sidebar';
import '../Admin.css';

const AdminLayout = ({ children }) => {
    return (
        <div className="admin-layout">
            <Sidebar />
            <div className="main-content">
                {children}
            </div>
        </div>
    );
};

export default AdminLayout;
